var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_892",
    "data-name": "Gruppe 892",
    transform: "translate(-1328 -342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_FILL1_wght400_GRAD0_opsz48",
    d: "M24,44A66.487,66.487,0,0,1,11.975,31.275Q8,25.4,8,20.4q0-7.5,4.825-11.95a16.257,16.257,0,0,1,22.35,0Q40,12.9,40,20.4q0,5-3.975,10.875A66.487,66.487,0,0,1,24,44Z",
    transform: "translate(1320 338)",
    fill: "#005851"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_876",
    "data-name": "Gruppe 876",
    transform: "translate(-42.443 747.732) rotate(-30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_872",
    "data-name": "Gruppe 872",
    transform: "translate(1385 350.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_49",
    "data-name": "Vereinigungsmenge 49",
    d: "M11.166,10.18H0V0H11.166c2.468,0,4.467,2.277,4.467,5.09s-2,5.09-4.467,5.09Z",
    transform: "translate(5.044)",
    fill: "#005851",
    stroke: "#d9e868",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_283",
    "data-name": "Ellipse 283",
    cx: 4.045,
    cy: 5.088,
    rx: 4.045,
    ry: 5.088,
    transform: "translate(0 0.001)",
    fill: "#005851",
    stroke: "#d9e868",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolter);
export default __webpack_public_path__ + "static/media/Polter.ae46224eeb4b437ea97737111d6c2bb5.svg";
export { ForwardRef as ReactComponent };